var map = {
	"./address_image.svg": 599,
	"./animated_logo.svg": 7733,
	"./blogs_image.svg": 2885,
	"./cloud_infrastructure.svg": 7957,
	"./contactMail.png": 9581,
	"./contact_me.png": 838,
	"./coursera_logo.png": 1877,
	"./data_science.svg": 8938,
	"./deeplearning_ai_logo.png": 2862,
	"./developerActivity.svg": 6715,
	"./education.svg": 855,
	"./experience.svg": 9917,
	"./feelingProud.svg": 658,
	"./fullstack.svg": 2043,
	"./gcp_logo.png": 1513,
	"./ginnovations.png": 3816,
	"./github_logo.png": 9551,
	"./googleAssistant.jpg": 700,
	"./googleAssistant.svg": 3564,
	"./google_logo.png": 5927,
	"./hust_logo.png": 3571,
	"./ibm_logo.png": 9561,
	"./intel_logo.jpg": 3026,
	"./jsFramework.svg": 8446,
	"./manOnTable.svg": 3034,
	"./microsoft_logo.png": 7231,
	"./portfolio.gif": 3549,
	"./programmer.svg": 9220,
	"./projects_image.svg": 4716,
	"./protonx.jpeg": 5497,
	"./pwa.png": 7758,
	"./talksCardBack.svg": 5331,
	"./talksCardBackAlt.svg": 7945,
	"./ui_ux_design.svg": 2337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;